module.exports = __webpack_public_path__ + "static/img/down_img02.png.871a3f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sptj/down_img02.png.png
// module id = GECH
// module chunks = 1